import { render, staticRenderFns } from "./WishlistAddingDialog.vue?vue&type=template&id=a8ddd396&"
import script from "./WishlistAddingDialog.vue?vue&type=script&lang=js&"
export * from "./WishlistAddingDialog.vue?vue&type=script&lang=js&"
import style0 from "./WishlistAddingDialog.vue?vue&type=style&index=0&id=a8ddd396&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports